import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawRestartIcon from "./RawRestartIcon.svg.jsx";

const RestartIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawRestartIcon} {...props} />;
});

export default RestartIcon;
